/** Company admin is user_type 2 (DB / JWT). */

export function decodeCustomerJwtPayload(
  token: string,
): { user: Record<string, unknown> } | null {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    const parsed = JSON.parse(jsonPayload) as {
      user?: Record<string, unknown>;
    };
    if (parsed?.user && typeof parsed.user === "object")
      return { user: parsed.user };
    return null;
  } catch {
    return null;
  }
}

export function isCompanyAdminUserType(
  userType: string | number | undefined | null,
): boolean {
  if (userType === undefined || userType === null || userType === "")
    return false;
  return Number(userType) === 2;
}

export function isCompanyAdminFromToken(
  token: string | null | undefined,
): boolean {
  if (!token) return false;
  const payload = decodeCustomerJwtPayload(token);
  const ut = payload?.user?.user_type;
  return isCompanyAdminUserType(ut as string | number | undefined);
}
